import config from '../const/config';
export default (function () {
    var HOST_URL = "https://".concat(window.location.host);
    return HOST_URL.includes('localhost') ? config.ASSET_HOST : HOST_URL;
});
